import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=10130fce&scoped=true"
import script from "./FrontPage.vue?vue&type=script&lang=js"
export * from "./FrontPage.vue?vue&type=script&lang=js"
import style0 from "./FrontPage.vue?vue&type=style&index=0&id=10130fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10130fce",
  null
  
)

export default component.exports